"use strict";

var _classCallCheck = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ValidationError = exports.StateError = exports.SearchError = exports.PermissionError = exports.ParseError = exports.CompilationError = exports.CommandNotFoundError = void 0;

require("source-map-support/register");

var CommandNotFoundError = /*#__PURE__*/function (_Error) {
  _inherits(CommandNotFoundError, _Error);

  var _super = _createSuper(CommandNotFoundError);

  function CommandNotFoundError(message) {
    var _this;

    _classCallCheck(this, CommandNotFoundError);

    _this = _super.call(this, message);
    _this.name = 'CommandNotFoundError';
    return _this;
  }

  return CommandNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.CommandNotFoundError = CommandNotFoundError;

var CompilationError = /*#__PURE__*/function (_Error2) {
  _inherits(CompilationError, _Error2);

  var _super2 = _createSuper(CompilationError);

  function CompilationError(message) {
    var _this2;

    _classCallCheck(this, CompilationError);

    _this2 = _super2.call(this, message);
    _this2.name = 'CompilationError';
    return _this2;
  }

  return CompilationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.CompilationError = CompilationError;

var ParseError = /*#__PURE__*/function (_Error3) {
  _inherits(ParseError, _Error3);

  var _super3 = _createSuper(ParseError);

  function ParseError(message) {
    var _this3;

    _classCallCheck(this, ParseError);

    _this3 = _super3.call(this, message);
    _this3.name = 'ParseError';
    return _this3;
  }

  return ParseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ParseError = ParseError;

var PermissionError = /*#__PURE__*/function (_Error4) {
  _inherits(PermissionError, _Error4);

  var _super4 = _createSuper(PermissionError);

  function PermissionError(message) {
    var _this4;

    _classCallCheck(this, PermissionError);

    _this4 = _super4.call(this, "Permission Error: ".concat(message));
    _this4.name = 'PermissionError';
    return _this4;
  }

  return PermissionError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.PermissionError = PermissionError;

var SearchError = /*#__PURE__*/function (_Error5) {
  _inherits(SearchError, _Error5);

  var _super5 = _createSuper(SearchError);

  function SearchError(message) {
    var _this5;

    _classCallCheck(this, SearchError);

    _this5 = _super5.call(this, message);
    _this5.name = 'SearchError';
    return _this5;
  }

  return SearchError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.SearchError = SearchError;

var StateError = /*#__PURE__*/function (_Error6) {
  _inherits(StateError, _Error6);

  var _super6 = _createSuper(StateError);

  function StateError(message) {
    var _this6;

    _classCallCheck(this, StateError);

    _this6 = _super6.call(this, message);
    _this6.name = 'StateError';
    return _this6;
  }

  return StateError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.StateError = StateError;

var ValidationError = /*#__PURE__*/function (_Error7) {
  _inherits(ValidationError, _Error7);

  var _super7 = _createSuper(ValidationError);

  function ValidationError(message) {
    var _this7;

    _classCallCheck(this, ValidationError);

    _this7 = _super7.call(this, message);
    _this7.name = 'ValidationError';
    return _this7;
  }

  return ValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ValidationError = ValidationError;
var _default = {
  CommandNotFoundError: CommandNotFoundError,
  CompilationError: CompilationError,
  ParseError: ParseError,
  PermissionError: PermissionError,
  SearchError: SearchError,
  StateError: StateError,
  ValidationError: ValidationError
};
exports.default = _default;